interface IconProps {
  className?: string;
}
export const ChevronLeftIcon: React.FC<IconProps> = ({
  className
}) => <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' className={className} data-sentry-element="svg" data-sentry-component="ChevronLeftIcon" data-sentry-source-file="ChevronLeftIcon.tsx">
        <path d='M7.21665 8.00047L10.5165 11.3003L9.57372 12.2431L5.33105 8.00047L9.57372 3.75781L10.5165 4.70062L7.21665 8.00047Z' fill='currentColor' data-sentry-element="path" data-sentry-source-file="ChevronLeftIcon.tsx" />
    </svg>;